import Nullstack from 'nullstack';
export default function IconCaravan({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-caravan",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "11",
    cy: "17",
    r: "2"
  }), "   ", Nullstack.element("line", {
    x1: "21",
    y1: "17",
    x2: "13",
    y2: "17"
  }), "   ", Nullstack.element("path", {
    d: "M9 17h-5a1 1 0 0 1 -1 -1v-9a2 2 0 0 1 2 -2h10l4 4v8"
  }), "   ", Nullstack.element("rect", {
    x: "6",
    y: "8",
    width: "6",
    height: "4",
    rx: "1"
  }), " ");
}